import { Delete, Get, Patch } from "axios/AxiosFunctions";
import { DropDown } from "components/Core/DropDown";
import RenderToast from "components/Core/RenderToast";
import SearchInput from "components/Core/SearchInput";
import SideBarSkeleton from "components/Core/SideBarSkeleton";
import Statuses from "components/Core/Statuses";
import TableStructure from "components/Core/TableStructure";
import TabsComponent from "components/Core/TabsComponent";
import TableActionHandler from "components/TableActionHandler";
import { apiHeader, BaseURL } from "config/apiUrl";
import { recordsLimit } from "constant/constants";
import { formTabHeader, formTableHeaders } from "constant/data";
import useDebounce from "customHooks/useDebounce";
import AreYouSureModal from "modals/AreYouSureModal";
import ViewFormsModal from "modals/ViewFormsModal";
import { useEffect, useState } from "react";
import { PiHandWavingFill } from "react-icons/pi";
import { useSelector } from "react-redux";
import classes from "./Forms.module.css";
import { set } from "date-fns";
import ChangeStatusModal from "modals/ChangeStatusModal";

export default function Forms() {
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [formData, setFormData] = useState([]);
  const [searchData, setSearchData] = useState("");
  const [modal, setModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [activeTab, setActiveTab] = useState(formTabHeader[0]);
  const [totalRecordsData, setTotalRecordsData] = useState(0);
  const [filter, setFilter] = useState(filterOptions[0]);
  const debounce = useDebounce(searchData, 500);
  const { access_token } = useSelector((state) => state?.authReducer);

  const getFormData = async (
    pageNo = page,
    tab = activeTab?.value,
    _filter = filter?.value
  ) => {
    setLoading("get-data");
    const params = {
      page: pageNo,
      limit: recordsLimit,
      search: searchData,
      status: _filter,
      type: tab,
    };
    const url = BaseURL(`contact-us/all?${new URLSearchParams(params)}`);
    const response = await Get(url, access_token);
    if (response !== undefined) {
      setFormData(response?.data?.data?.forms);
      setTotalRecordsData(response?.data?.data?.totalCount);
    }
    setLoading(false);
  };
  const deleteData = async () => {
    const url = BaseURL(`contact-us/${selectedItem?._id}`);
    setLoading("delete");

    const response = await Delete(url, apiHeader(access_token));
    if (response !== undefined) {
      RenderToast({ type: "success", message: "Form Deleted Successfully" });
      setFormData((prev) =>
        prev.filter((item) => item?._id !== selectedItem?._id)
      );
    }
    setSelectedItem(null);
    setModal(false);
  };
  const handleChangeStatus = async (statusVal) => {
    const url = BaseURL(`contact-us/update`);
    let params = {
      formId: selectedItem?._id,
      status: statusVal,
    };
    setLoading("change-status");
    const response = await Patch(url, params, apiHeader(access_token));
    if (response !== undefined) {
      RenderToast({
        type: "success",
        message: `Status has been ${
          selectedItem?.status === "active" ? "Deactivated" : "Activated"
        } successfully`,
      });
      setFormData((prev) =>
        prev.map((item) =>
          item?._id === selectedItem?._id
            ? { ...item, status: statusVal }
            : item
        )
      );
    }
    setSelectedItem(null);
    setModal(false);
  };
  useEffect(() => {
    setPage(1);
    getFormData(1, activeTab?.value, filter?.value);
  }, [debounce]);

  return (
    <SideBarSkeleton headerHeading={"Forms"} icon={<PiHandWavingFill />}>
      <div className={classes.forms_page_container}>
        <TableStructure
          isLoading={loading === "get-data"}
          page={page}
          setPage={(e) => {
            setPage(e);
            getFormData(e, activeTab?.value, filter?.value);
          }}
          headerTitle={
            <TabsComponent
              data={formTabHeader}
              value={activeTab}
              onClick={(e) => {
                setActiveTab(e);
                setPage(1);
                getFormData(1, e?.value, filter?.value);
              }}
            />
          }
          headerHandlers={{
            search: (
              <div className={classes.search}>
                <SearchInput
                  placeholder={"Search"}
                  value={searchData}
                  setter={setSearchData}
                />
              </div>
            ),
            filter: (
              <div className={classes.filter}>
                <DropDown
                  setter={(e) => {
                    setFilter(e);
                    setPage(1);
                    getFormData(1, activeTab?.value, e?.value);
                  }}
                  value={filter}
                  options={filterOptions}
                  placeholder={"Filter"}
                />
              </div>
            ),
          }}
          tableHeaders={formTableHeaders}
          tableContent={formData?.map((ele) => ({
            ...ele,
            message: <div className={classes.description}>{ele?.message}</div>,
            status: <Statuses status={ele?.status} />,
            action: (
              <TableActionHandler
                onDelete={() => {
                  setSelectedItem(ele);
                  setModal("delete");
                }}
                onView={() => {
                  setSelectedItem(ele);
                  setModal("view");
                }}
                onAssign={() => {
                  setSelectedItem(ele);
                  setModal("assign");
                }}
              />
            ),
          }))}
          totalRecord={totalRecordsData}
          recordLimit={recordsLimit}
          noDataMessage={"No Forms Found"}
          customStyle={{ height: "calc(100vh - 278px)" }}
        />
      </div>
      {modal === "view" && (
        <ViewFormsModal show={modal} setShow={setModal} data={selectedItem} />
      )}
      {modal === "delete" && (
        <AreYouSureModal
          show={modal}
          setShow={setModal}
          onClick={deleteData}
          isApiCall={loading === "delete"}
          title={"Delete Form"}
          subTitle={`you want to delete ${selectedItem?.fullName}`}
        />
      )}
      {modal === "assign" && (
        <ChangeStatusModal
          show={modal}
          setShow={setModal}
          selectedStatus={selectedItem?.status}
          onclick={handleChangeStatus}
          loading={loading === "change-status"}
        />
      )}
    </SideBarSkeleton>
  );
}
const filterOptions = [
  { value: "all", label: "All" },
  { value: "pending", label: "Pending" },
  { value: "completed", label: "Completed" },
];
